import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { successToast } from "../../Utils/utils";
import { initSubmitButtons, reloadTasks, showTask } from "../Exam";
import { showResults } from "../Results/Results";
import { answers } from "../Submit/SaveAnswer";
import { getSelfRatings } from "./GetSelfRatings";
import { transformDrToSelf } from "./transformDr";
import { transformFtToSelf } from "./transformFt";
import { transformIfToSelf } from "./transformIf";
import { transformLaToSelf } from "./transformLa";
import { transformMcToSelf } from "./transformMc";
import { transformOrToSelf } from "./transformOr";
import { transformScToSelf } from "./transformSc";
import { transformSfToSelf } from "./transformSf";

export var testNr = 0;

export function showSelfRating(tasksToDo:Array<number>, results:answers, testNr:number){
    
    testNr = testNr;
    $(document.body).append('<input id="test-nr" value="' + testNr + '" type="hidden">')

    $(".tab").each((ind, obj) => {
        const taskId = Number($(obj).attr("data-aufgabe"));
        if (!tasksToDo.includes(taskId)){
            $(obj).hide();
            $(obj).removeClass("tab").addClass("hidden-tab");
        }
    })

    addExplaination();

    reloadTasks();
    $(".tab").hide().removeClass("p-active");
    showTask(0);

    handleAnswers(tasksToDo, results)

    addListeners();

    initSubmitButtons('self');

    MathJax.typeset();
}

function addExplaination(){
    const html = '<div class="form-wrapper" id="self-explaination">'+
    '<div class="result"><h3>Selbstbewertungsmodus</h3><p>Bitte bewerte deine Eingaben in Text- und Bildform nach dem Daumen-Prinzip.</p></div></div>'+
    '</div>'
    $("#ab-form").prepend(html);
}

export function submitAbSelf(btn){
    const ratings = getSelfRatings();
    const testNr =  $("#test-nr").val();

    const url = '/submission/' + testNr.toString() + '/rating/self'

    const data = {
        ratings: ratings
    }

    const success = function (data){
        successToast("Deine Abgabe wurde ausgewertet", "Erfolg", 4500, true);
        revertSelfRatingChanges();
        showResults(data.answers, data.times, data.test.show_grade, data.test.show_time_analysis, data.updated_at);
    }

    const request = ajaxRequest(url, success, data, btn)
    request.done((response) => {
        MathJax.typeset();
    })


}

function revertSelfRatingChanges(){
    $(".hidden-tab").removeClass("hidden-tab").addClass("tab");
    $(".flex-rating").remove();
    $(".self-input").remove();
    $(".self-head").remove();
    $(".ft_right_antwort").remove();
    $("#self-explaination").remove();
}

function changeSubmitButtons(){
    $(".submit-ab").removeClass("submit-ab").addClass("submit-self-ab");
}

function handleAnswers(tasksToDo:Array<number>, results:answers){

    for (const [taskId, resultsItem] of Object.entries(results.tasks)){

        if (tasksToDo.includes(Number(taskId))){
            const tab = $(".tab[data-aufgabe=" + taskId + "]");
            handleTask(tab, taskId, resultsItem);
        }

    }
}

function handleTask(tab, taskId, resultsItem){
    for (const [inputId, resultItem] of Object.entries(resultsItem.inputs)){
        const input = tab.find(".input[data-id=" + inputId + "]");
        handleInput(input, taskId, inputId, resultItem);
    }
}

function handleInput(input:JQuery, taskId:number, inputId:number, results:inputResult){
    const inputPoints = results.points;
    const inputPossilbe = results.possible;

    const type = input.attr('data-type');
    
    switch(type){
        case "if":
            transformIfToSelf(input, results, inputPoints, inputPossilbe)
        break;
        case "mc":
            transformMcToSelf(input, results, inputPoints, inputPossilbe)
        break;
        case "sc":
            transformScToSelf(input, results, inputPoints, inputPossilbe)
        break;
        case "sf":
            transformSfToSelf(input, results, inputPoints, inputPossilbe);
        break;
        case "ft":
            transformFtToSelf(input, results, inputPoints, inputPossilbe);
        break;
        case "la":
            transformLaToSelf(input, results, inputPoints, inputPossilbe);
        break;
        case "dr":
            transformDrToSelf(input, results, inputPoints, inputPossilbe);
        break;
        case "or":
            transformOrToSelf(input, results, inputPoints, inputPossilbe);
        break;
    }
}

function addListeners(){
    $(document).on("click", "#self-rating button", function(e){
        e.preventDefault();
        const value = $(this).attr('data-multi')
        const eingabe = $(this).attr('data-eingabe');
        $("input[name=" + eingabe + "]").val(value);
        
        const parent = $(this).parent();
        parent.find("button").removeClass("active");
        $(this).addClass("active");
    })
}